import React from 'react';

type Size = 'sm' | 'md' | 'lg';
type Variant = 'ring' | 'solid';

const sizeMap: Record<Size, number> = { sm: 10, md: 12, lg: 14 };
const borderMap: Record<Size, number> = { sm: 2, md: 2, lg: 3 };

export interface RowerDotProps {
  color: string; // hex/rgb
  size?: Size;
  variant?: Variant;
  title?: string;
  className?: string;
}

/**
 * RowerDot — unified visual token for rower indicators (charts, lists, legends).
 *
 * - ring: white center with colored border (matches Chart.js legend look)
 * - solid: filled circle (for side lists, compact UIs)
 */
export const RowerDot: React.FC<RowerDotProps> = ({
  color,
  size = 'md',
  variant = 'ring',
  title,
  className = '',
}) => {
  const d = sizeMap[size];
  const bw = borderMap[size];
  const style: React.CSSProperties =
    variant === 'ring'
      ? {
          width: d,
          height: d,
          borderRadius: '9999px',
          border: `${bw}px solid ${color}`,
          backgroundColor: '#ffffff',
          boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        }
      : {
          width: d,
          height: d,
          borderRadius: '9999px',
          backgroundColor: color,
          boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
          border: '1px solid rgba(0,0,0,0.06)',
        };

  return <span role="img" aria-label={title} title={title} className={className} style={style} />;
};

export default RowerDot;
